"use strict";

exports.__esModule = true;
exports.default = void 0;

var _app = _interopRequireDefault(require("./app.dashboard"));

var _app2 = _interopRequireDefault(require("./app.profile"));

var _app3 = _interopRequireDefault(require("./app.inbox"));

var _app4 = _interopRequireDefault(require("./app.calendar"));

var _app5 = _interopRequireDefault(require("./app.analytics"));

var _app6 = _interopRequireDefault(require("./app.admin"));

var _app7 = _interopRequireDefault(require("./app.forum"));

var _app8 = _interopRequireDefault(require("./app.support"));

var _owner = _interopRequireDefault(require("./owner.rock"));

var _owner2 = _interopRequireDefault(require("./owner.nf"));

var _owner3 = _interopRequireDefault(require("./owner.mia"));

var _ownerMia = _interopRequireDefault(require("./owner.mia.oslofjord"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const apps = [_app.default, _app3.default, _app4.default, _app5.default, _app7.default, _app8.default, _app2.default, _app6.default];
const owners = [_owner.default, _owner2.default, _owner3.default, _ownerMia.default];
const user = {
  uniqueId: 1,
  name: "User Name",
  email: "user.name@kulturit.no",
  apps: apps,
  owners: owners
};
var _default = user;
exports.default = _default;
module.exports = exports.default;